export const Section1 = {
	heading: "How I'm Using Beacon Discovery to Prepare for Expo West 2025",
	content1:
		' excites me with its thousands of exhibitors, education sessions, and opportunities for connecting with natural products industry leaders. But with even more to see in 2025 — how do I plan my time effectively with the new show schedule?',
	content2:
		', but with new integrated navigation and more products than ever before, there are even more tools to help buyers and attendees make the most of their time at the show. ',
	content3:
		'As the official product discovery platform of Natural Products Expo, I’m using it to prepare for the event months in advance and to help stay focused amidst the excitement.',
	content4:
		'Access to Beacon Discovery is included with your registration costs. Create your account here by clicking “Sign Up” in the upper right corner. After providing basic information, you’ll be asked to select an ingredients template before continuing. These can be changed at any time, and are meant to help align your search most closely with your store standards — but you can trust all products on Beacon Discovery are compliant with '
};

export const Section2 = {
	heading: 'Step 1: Discovering Products Tailored to My Needs',
	smalltext: 'What helped me: ',
	item1: {
		content_bold: 'Sort By – Expo West: ',
		content:
			'Products that will be at Expo West feature an orange banner – visit product pages to see their booth number.'
	},
	item2: {
		content_bold: 'Regions and Distributors: ',
		content:
			'I didn’t want my search cluttered with products that aren’t available in my area or through my existing partners.'
	},
	item3: {
		content_bold: 'Top Attributes: ',
		content:
			'I focused on Clean Label and Made in USA products, which are priorities for my search at Expo.'
	},
	item4: {
		content_bold: 'Certifications:',
		content:
			'I looked for products with Certified Organic and Certified Non-GMO labels to align with customers’ values.'
	},
	content1:
		'helped me learn about the product’s manufacturing techniques, packaging, and sales information. I can also visit brand pages to read each brand’s story, mission, and standout features. This level of insight ensures that I’m not just discovering products, but also finding ones that truly resonate with my customers. And best of all – it’s all in one place. '
};

export const Section3 = {
	heading: 'Step 2: Favoriting My Top Picks',
	content1:
		'Once I found products and brands that caught my attention, I used the “Favorite” feature to create a shortlist. This has been a lifesaver for me because:',
	item1:
		'It keeps all my must-visit exhibitors in one place, and I can access it anytime, anywhere. Having this digital tool feels like carrying a personalized guidebook that adapts to my needs.',
	item2:
		'I can access this list during the show to add new favorites, so I don’t have to remember everything I’ve seen—it’s all saved in my Beacon Discovery account.',
	item3: 'I can share my list of favorites with colleagues via CSV to help our team stay aligned.',
	content2:
		'You can share individual products or brand pages with the rest of your team – even if they’re not on Beacon Discovery yet!'
};

export const Section4 = {
	heading: 'Step 3: Navigating with the Interactive Map',
	content1:
		'with the Expo West event app is my secret weapon to ensure I’m able to find each brand I want to connect with. That’s where your favorites come in!',
	content2:
		'Then, register or log in with the same email address you used to register for Beacon Discovery. You’ll be able to see your favorites from Beacon Discovery highlighted throughout the floor plans on the app.'
};

export const Section5 = {
	heading: 'Step 4: Meet with Exhibitors',
	content1:
		'The best part of Beacon Discovery is how it helps connections go beyond walking the floor. With all the brand profiles and contact information available, you can:',
	item1: {
		content: 'Reach out to brand or broker contacts to ask questions or request samples',
		contentbold: ' before or after the show.'
	},
	item2: {
		content: 'Learn more about their products and mission so you can come prepared to discuss ',
		contentbold: 'partnerships.'
	},
	item3: {
		content1:
			'Save time by filtering out products that don’t match what I’m looking for, ensuring ',
		contentbold: 'meaningful conversations',
		content2: ' rather than rushed interactions.'
	}
};

export const Section6 = {
	heading: "Bonus Tips I've Picked Up:",
	item1: {
		contentbold: 'Start Early: ',
		content:
			' I started using Beacon Discovery to prep for my show as soon as I saw the orange “Expo West” tags go up on the product cards. You don’t have to wait for the Expo West app to go live – and this early prep has been crucial for reducing stress.'
	},
	item2: {
		contentbold: 'Filter Smart:',
		content: ' With over 100 filters available, I took my time to refine my search—it’s worth it.'
	},
	item3: {
		contentbold: 'Stay Flexible: ',
		content:
			'While I’ve planned my days, I’m leaving room for unexpected finds and new connections. Exhibitors are uploading products through the end of February, and there’s always something new to discover on Beacon!'
	}
};

export const Section7 = {
	heading: "What I'm Looking Forward To",
	content:
		'With Beacon Discovery’s help, I’m walking into Expo West 2025 with confidence and clarity. I’ve already identified dozens of innovative products, and I’m excited to connect with some incredible brands. The new hours and vast layout no longer feel daunting—instead, I feel ready to tackle the show floor with purpose. I feel more organized, less nervous, and genuinely excited to make the most of my time, and using Beacon Discovery to prepare is a big part of that. If you’re attending, I highly recommend giving Beacon Discovery a try—it’s been a lifesaver for me.'
};

export enum Links {
	expo_west = 'https://www.expowest.com/en/home.html',
	beacon_discovery = 'https://beaconapp.newhope.com/',
	newhope_standrad = 'https://standards.newhope.com/ingredient-standards-guidelines/'
}

export enum Images {
	beaconHome = 'https://s44021.pcdn.co/wp-content/uploads/2025/01/User-BeaconHome-1536x864.png',
	sort = 'https://s44021.pcdn.co/wp-content/uploads/2025/01/User-SortBy.png',
	picks = 'https://s44021.pcdn.co/wp-content/uploads/2025/01/User-Favorites-Mobile-e1738795544833.png',
	naturalprod_home = 'https://s44021.pcdn.co/wp-content/uploads/2025/01/User-Show-App-e1738785570389.png',
	greet = 'https://s44021.pcdn.co/wp-content/uploads/2025/01/IMG_4394-1536x1024.jpg'
}
